module.exports = __webpack_public_path__ + "media/background.29a63f28.mp4";